import { render, staticRenderFns } from "./externalUserSend.vue?vue&type=template&id=2b15f4cc&scoped=true&"
import script from "./externalUserSend.vue?vue&type=script&lang=js&"
export * from "./externalUserSend.vue?vue&type=script&lang=js&"
import style0 from "./externalUserSend.vue?vue&type=style&index=0&id=2b15f4cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b15f4cc",
  null
  
)

export default component.exports